import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styled from 'styled-components';
import LinkedBooksDropDown from './LinkedBooksDropDown';
import CustomIcon from '../../common/CustomIcon';
import * as bookApi from '../../../services/api/bookApi';
import { ROLE } from '../../../const';

const DesynchronizeButton = styled.div`
  width: 232px;
  height: 40px;
  border-radius: 40px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #f8b02f;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
`;

const DesynchronizeButtonText = styled.div`
  width: 164px;
  font-family: 'LatoSemibold', 'DefaultLatoBold', 'sans-serif';
  font-size: 16px;
  color: white;
  margin-left: 13px;
`;

let timeout;

const parseLinkedClassrooms = response => {
  const data = response && response.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return [];
};

class DesynchronizeDropdown extends Component {
  state = {
    isHovering: false,
    isLinked: false,
    linkedClassrooms: [],
    hasChecked: false
  };

  componentDidMount() {
    this.fetchLinkedClassrooms();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activityId !== this.props.activityId || prevProps.sectionId !== this.props.sectionId) {
      this.fetchLinkedClassrooms();
      return;
    }

    const { activityLinkChanged, activityId } = this.props;
    if (prevProps.activityLinkChanged !== activityLinkChanged && activityLinkChanged) {
      const changedActivityIds =
        activityLinkChanged.activityIds ||
        (activityLinkChanged.activityId ? [activityLinkChanged.activityId] : []);

      if (changedActivityIds.includes(activityId)) {
        this.fetchLinkedClassrooms();
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(timeout);
  }

  fetchLinkedClassrooms = () => {
    const { activityId, sectionId, role } = this.props;

    if (role === ROLE.STUDENT) {
      this.setState({ isLinked: false, hasChecked: true, linkedClassrooms: [] });
      return;
    }

    if (!activityId || !sectionId) {
      this.setState({ isLinked: false, hasChecked: true, linkedClassrooms: [] });
      return;
    }

    bookApi
      .getLinkedClassroomsForActivity(activityId, sectionId)
      .then(res => {
        const linkedClassrooms = parseLinkedClassrooms(res);
        this.setState({
          linkedClassrooms,
          isLinked: linkedClassrooms.length > 1,
          hasChecked: true
        });
      })
      .catch(() => {
        this.setState({ isLinked: false, hasChecked: true, linkedClassrooms: [] });
      });
  };

  handleMouseEnter = () => {
    clearTimeout(timeout);
    this.setState({ isHovering: true });
  };

  handleMouseLeave = () => {
    timeout = setTimeout(() => this.setState({ isHovering: false }), 200);
  };

  render() {
    const { isHovering, isLinked, linkedClassrooms, hasChecked } = this.state;

    if (!hasChecked || !isLinked) {
      return null;
    }

    return (
      <DesynchronizeButton onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <CustomIcon name="share-content" size={16} color={'#FFFFFF'} />
        <DesynchronizeButtonText>{I18n.t('bookContainer.classroomSynchronizedButton')}</DesynchronizeButtonText>
        {isHovering && <LinkedBooksDropDown synchronizedClassrooms={linkedClassrooms} />}
      </DesynchronizeButton>
    );
  }
}

DesynchronizeDropdown.propTypes = {
  activityId: PropTypes.string,
  sectionId: PropTypes.string,
  activityLinkChanged: PropTypes.object,
  role: PropTypes.string
};

const mapStateToProps = state => ({
  activityId: state.book.book && state.book.book.activityId,
  sectionId: state.classrooms.selectedClassroom.classroom.sectionId,
  activityLinkChanged: state.book.activityLinkChanged,
  role: state.classrooms.selectedClassroom.classroom.role
});

export default connect(mapStateToProps)(DesynchronizeDropdown);
